import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'LogDownload',
  components: {
    Loading,
    Datepicker
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,

      // date picker option
      serviceStartDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      serviceEndDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      analysisStartDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },
      videoChatStartDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: null,
          from: null
        }
      },

      // 検索
      searchService: '',
      searchDevice: '',

      // 入力
      inpServiceLog: null,
      inpServiceStartDate: '',
      inpServiceEndDate: '',

      inpAnalysisLog: null,
      inpAnalysisStartDate: '',

      inpVideoChatLog: null,
      inpVideoChatStartDate: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // サービス開始日
      serviceStartDate: null,
      // サービスログの最大集計期間（日）
      serviceMaxDays: 7,
      // ささえiでんわの最大集計期間（日）
      videochatMaxDays: 30
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.logDownload.categoryName,
      serviceModel: state => state.logDownload.serviceModel,
      serviceDeviceModel: state => state.logDownload.serviceDeviceModel,
      serviceInfoModel: state => state.logDownload.serviceInfoModel,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    serviceList () {
      let list = []
      this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .forEach(item => list.push({
        value: item.serviceUuid,
        label: item.serviceName
      }))
      return list
    },
    deviceList () {
     return this.serviceDeviceModel
        .filter((model, index, array) => {
          return array.findIndex(item => item.deviceTypeUuid === model.deviceTypeUuid) === index
        })
        .map(model => {
          return {
            value: model.deviceTypeUuid,
            label: model.modelNumber
          }
        })
    },
    serviceLogList () {
      return Constants.Log.Service
    },
    operatorServiceLogList () {
      return Constants.Log.OperatorService
    },
    analysisLogList () {
      return Constants.Log.Analysis
    },
    videoChatLogList () {
      return Constants.Log.VideoChat
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },

    // enable
    selectedService () {
      return this.searchService !== ''
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // form
    disableDownloadServiceButton () {
      // return this.searchService === '' ||
      //   this.inpServiceStartDate === '' ||
      //   this.inpServiceEndDate === '' ||
      //   this.inpServiceLog === null
      if (this.searchService === '') return true;
      if (this.inpServiceStartDate === '') return true;
      if (this.inpServiceEndDate === '') return true;
      if (this.inpServiceLog === null) return true;

      // 開始日: 設定可能な期間内の日付設定がされているか確認
      const startValue = moment(this.inpServiceStartDate);
      const startMin = moment(this.serviceStartDateOptions.disabledDates.to)
      const startMax = moment(this.serviceStartDateOptions.disabledDates.from)
      const startInvalid = startValue.isAfter(startMax) || startValue.isBefore(startMin)
      if (startInvalid) return true;

      // 終了日: 設定可能な期間内の日付設定がされているか確認
      const endValue = moment(this.inpServiceEndDate);
      const endMin = moment(this.serviceEndDateOptions.disabledDates.to)
      const endMax = moment(this.serviceEndDateOptions.disabledDates.from)
      const endInvalid = endValue.isAfter(endMax) || endValue.isBefore(endMin)
      if (endInvalid) return true;

      return false
    },
    disableDownloadAnalysisButton () {
      if (this.searchService === '') return true;
      if (this.inpAnalysisStartDate === '') return true;
      if (this.inpAnalysisLog === null) return true;

      // 設定可能な期間内の日付設定がされているか確認
      const value = moment(this.inpAnalysisStartDate);
      const min = moment(this.analysisStartDateOptions.disabledDates.to)
        .startOf('month')
      const max = moment(this.analysisStartDateOptions.disabledDates.from)
      const invalid = value.isAfter(max) || value.isBefore(min)
      return invalid;
    },
    disableDownloadVideoChatButton () {
      // return this.searchService === '' ||
      //   this.inpVideoChatStartDate === '' ||
      //   this.inpVideoChatEndDate === '' ||
      //   this.inpVideoChatLog === null
      if (this.searchService === '') return true;
      if (this.inpVideoChatStartDate === '') return true;
      if (this.inpVideoChatLog === null) return true;

      // 開始日: 設定可能な期間内の日付設定がされているか確認
      const startValue = moment(this.inpVideoChatStartDate);
      const startMin = moment(this.videoChatStartDateOptions.disabledDates.to)
      const startMax = moment(this.videoChatStartDateOptions.disabledDates.from)
      const startInvalid = startValue.isAfter(startMax) || startValue.isBefore(startMin)
      if (startInvalid) return true;

      return false
    },

    // 現在から90日前
    before90Days() {
      return moment().add('days', -90);
    },
    // サービス開始日と90日前を比較して、新しい方を返す
    minDate() {
      return this.serviceStartDate.isAfter(this.before90Days)
        ? this.serviceStartDate
        : this.before90Days
    },

    // サービス集計ログ開始日:
    serviceLogStartMinDate() {
      if (this.inpServiceEndDate === '') {
        return this.minDate.toDate()
      } else {
        const minTerm = moment(this.inpServiceEndDate).add('days', -1 * this.serviceMaxDays)
        return this.minDate.isAfter(minTerm)
          ? this.minDate.toDate()
          : minTerm.toDate()
      }
    },
    // サービス集計ログ開始日:
    serviceLogStartMaxDate() {
      if (this.inpServiceEndDate === '') {
        return moment().toDate();
      } else {
        return moment(this.inpServiceEndDate).toDate()
      }
    },
    // サービス集計ログ終了日:
    serviceLogEndMinDate() {
      if (this.inpServiceStartDate === '') {
        return this.minDate.toDate()
      } else {
        return moment(this.inpServiceStartDate).toDate()
      }
    },
    // サービス集計ログ終了日:
    serviceLogEndMaxDate() {
      if (this.inpServiceStartDate === '') {
        return moment().toDate();
      } else {
        const current = moment()
        const maxTerm = moment(this.inpServiceStartDate).add('days', this.serviceMaxDays)
        return current.isAfter(maxTerm)
          ? maxTerm.toDate()
          : current.toDate()
      }
    },
  },
  watch: {
    searchService: function (to) {
      this.resetSearch(true)

      if (to) {
        if (this.isAdmin) {
          const communityUuid = this.serviceModel
            .find(item => item.serviceUuid === to).communityUuid

          // サービスが選択されたら紐づくデバイスリストを取得
          let deviceParams = {
            filters: {
              communityUuid: [communityUuid]
            }
          }

          this.loadServiceDeviceList({
            deviceParams: deviceParams
          })
            // eslint-disable-next-line
            .then(res => {

            })
            .catch(error => {
              this.showError(error || null)
            })
        }

        let timestamp = this.isAdmin
          ? this.serviceModel
              .filter(item => item.serviceUuid === this.searchService)[0].createdAt
          : this.serviceInfoModel.createdAt

        // サービス開始日
        this.serviceStartDate = moment(timestamp);

        // サービスログ対象期間の開始日の最小設定
        this.serviceStartDateOptions.disabledDates.to = this.serviceLogStartMinDate
        // サービスログ対象期間の開始日の最大設定
        this.serviceStartDateOptions.disabledDates.from = this.serviceLogStartMaxDate
        // サービスログ対象期間の終了日の最小設定
        this.serviceEndDateOptions.disabledDates.to = this.serviceLogEndMinDate
        // サービスログ対象期間の終了日の最大設定
        this.serviceEndDateOptions.disabledDates.from = this.serviceLogEndMaxDate

        // 集計ダウンロード
        // サービス開始月と前月で新しい方を取得
        // const toMoment = moment(timestamp).isAfter(moment().add(-1, 'month'))
        //     ? moment(timestamp)
        //     : moment().add(-1, 'month');
        const toMoment = moment(timestamp);
        this.analysisStartDateOptions.disabledDates.to = toMoment.toDate()
        this.analysisStartDateOptions.disabledDates.from = moment().add(-1, 'month').toDate()

        // ささえiでんわログ対象期間の開始日の最小設定
        this.videoChatStartDateOptions.disabledDates.to = toMoment.toDate()
        // ささえiでんわログ対象期間の開始日の最大設定
        this.videoChatStartDateOptions.disabledDates.from = moment().add(-1, 'month').toDate()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showToast: 'toast/show',
      loadModel: 'logDownload/loadModel',
      loadServiceDeviceList: 'logDownload/loadServiceDeviceList'
    }),

    init () {
      this.loading = true

      const serviceParams = this.isAdmin
        ? {}
        : {
          serviceUuid: this.userServiceUuid
        }

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false

          if (this.isOperator) {
            this.searchService = this.userServiceUuid
          }
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 検索
    resetSearch (ignoreService) {
      if (!ignoreService) {
        this.searchService = ''
      }
      this.searchDevice = ''
      this.inpServiceLog = null
      this.inpServiceStartDate = ''
      this.inpServiceEndDate = ''
      this.inpAnalysisLog = null
      this.inpAnalysisStartDate = ''
      this.inpVideoChatLog = null
      this.inpVideoChatStartDate = ''
    },
    search () {
      this.loading = true

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 対象期間
    changeServiceStartDate (value) {
      if (value === null) {
        this.inpServiceStartDate = ''
      } else {
        let dateObj = new Date(value)
        this.inpServiceStartDate = new Date(dateObj.setHours(0,0,0,1))
      }

      this.serviceEndDateOptions.disabledDates.to = this.serviceLogEndMinDate
      this.serviceEndDateOptions.disabledDates.from = this.serviceLogEndMaxDate
    },
    changeServiceEndDate (value) {
      if (value === null) {
        this.inpServiceEndDate = ''
      } else {
        let dateObj = new Date(value)
        this.inpServiceEndDate = new Date(dateObj.setHours(0,0,0,1))
      }

      this.serviceStartDateOptions.disabledDates.to = this.serviceLogStartMinDate
      this.serviceStartDateOptions.disabledDates.from = this.serviceLogStartMaxDate
    },
    changeAnalysisStartDate (value) {
      if (value === null) {
        this.inpAnalysisStartDate = ''
        return
      }
      let dateObj = new Date(value)
      this.inpAnalysisStartDate = new Date(dateObj.setHours(0,0,0,1))
    },
    changeVideoChatStartDate (value) {
      if (value === null) {
        this.inpVideoChatStartDate = ''
      } else {
        let dateObj = new Date(value)
        this.inpVideoChatStartDate = new Date(dateObj.setHours(0,0,0,1))
      }
    },
    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    // ダウンロード
    downloadLog (type) {
      this.processing = true

      let parameters = {
        serviceUuid: this.searchService,
      }
      if (this.searchDevice) {
        parameters.deviceTypeUuid = this.searchDevice
      }

      switch(type) {
        case 'service':
          parameters.logType = this.inpServiceLog
          parameters.startDate = moment(this.inpServiceStartDate).format('YYYYMMDD')
          if (this.inpServiceEndDate) {
            parameters.endDate = moment(this.inpServiceEndDate).format('YYYYMMDD')
          }
          break
        case 'analysis':
          parameters.logType = this.inpAnalysisLog
          parameters.startDate = moment(this.inpAnalysisStartDate).format('YYYYMM')
          break
        case 'videoChat':
          parameters.logType = this.inpVideoChatLog
          parameters.startDate = moment(this.inpVideoChatStartDate).format('YYYYMM')
          break
      }
      parameters.key = Utility.generateUuid()
      console.log(parameters)

      // 登録
      ApiManager.request(
        ['log'],
        ['v1LogDownload'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            let name = ''
            switch(type) {
              case 'service':
                name = Utility.getConstantsLabel(['Log', 'Service'], parameters.logType)
                  + '_' + parameters.startDate
                if (parameters.endDate) {
                  name += ('_to_' + parameters.endDate)
                }
                // name = Utility.getConstantsLabel(['Log', 'Service'], parameters.logType) + '_' + parameters.startDate
                break
              case 'analysis':
                name = Utility.getConstantsLabel(['Log', 'Analysis'], parameters.logType)
                  + '_' + parameters.startDate
                // name = Utility.getConstantsLabel(['Log', 'Analysis'], parameters.logType) + '_' + parameters.startDate
                break
              case 'videoChat':
                name = Utility.getConstantsLabel(['Log', 'VideoChat'], parameters.logType)
                  + '_' + parameters.startDate
                // name = Utility.getConstantsLabel(['Log', 'VideoChat'], parameters.logType) + '_' + parameters.startDate
                break
            }
            Utility.downloadDataAsCsv(res[0].data, name + '.csv')
            // // toast
            // this.showToast({
            //   title: '',
            //   body: 'ダウンロードを完了しました。'
            // })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }

        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
  }
}